export default "__VITE_ASSET__B9scup5P__"